import Token from 'vindi-ds-tokens';

export default {
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '2em',
  },
  icon: {
    display: 'flex',
    fontSize: Token.font.size.large.value,
    color: Token.color.functional.dark[400].value,
  },
};
